import { render } from "./loginTwoFactor.vue?vue&type=template&id=9225a0ba&scoped=true"
import script from "./loginTwoFactor.vue?vue&type=script&lang=js"
export * from "./loginTwoFactor.vue?vue&type=script&lang=js"

import "./loginTwoFactor.vue?vue&type=style&index=0&id=9225a0ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9225a0ba"]])

export default __exports__